var map = {
	"./aparthotelclub/ic_tag_lightning.png": 74017,
	"./beachful/ic_tag_lightning.png": 83049,
	"./castlepedia/ic_tag_lightning.png": 97095,
	"./cocktayl/ic_tag_lightning.png": 47871,
	"./ic_tag_lightning.png": 42175,
	"./luxresortclub/ic_tag_lightning.png": 58324,
	"./parkful/ic_tag_lightning.png": 89502,
	"./prefabworld/ic_tag_lightning.png": 79697,
	"./rooftopclub/ic_tag_lightning.png": 49345,
	"./spaclub/ic_tag_lightning.png": 27498,
	"./worldcasino/ic_tag_lightning.png": 44978,
	"./zoopedia/ic_tag_lightning.png": 28306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87595;